module.exports = __webpack_public_path__ + "static/fonts/text-security-circle-compat.249aa2e.eot";